const base = {
  default: {
    padding: '14px',
    height: '70px',
    ['@media (max-width: 1000px)']: {
      padding: 0
    }
  }
};

const press = {
  default: {
    padding: '2rem 0 0',
    minHeight: '96px'
  }
};

const children = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default children;
